import React from "react";
import { useLocation } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import { useSideBar } from "./context/SideBarContext";
import { APP_VERSION, RECAPTCHA_SITE_KEY } from "../utils/constant";
import { Toaster } from 'react-hot-toast'
import { TOAST_OPTIONS } from "./user-pages/ui-helper";
import { ROUTES } from "../utils/key_helper";
import ContextWrapper from "./ContextWrapper";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AccountProgressLayout from "./shared/AccountProgressLayout";
const App = () => {
  console.log("APP VERSION", APP_VERSION);

  const location = useLocation(); // Replace withRouter with useLocation

  const { isSideBarOpen } = useSideBar();
  const noLayoutRoutes = [ROUTES.LOGIN, ROUTES.NOT_FOUND, ROUTES.FORGOT_PASSWORD, ROUTES.REGISTRATION];
  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY} scriptProps={{ async: true, defer: true, appendTo: 'head', nonce: undefined, }}>
        <Toaster position="top-center" toastOptions={TOAST_OPTIONS} containerStyle={{ zIndex: 9999999999 }} />
        {noLayoutRoutes.includes(location.pathname) ? (
          <AppRoutes />
        ) : (
          <ContextWrapper>
            <div className="container-scroller">
              <Sidebar />
              <div className="container-fluid page-body-wrapper">
                <Navbar />
                <div className="main-panel">
                  <div className={`content-wrapper ${isSideBarOpen ? "content-wrapper-margin" : "content-wrapper-margin2"} content-bg`} >
                    <AccountProgressLayout>
                      <AppRoutes />
                    </AccountProgressLayout>
                  </div>
                </div>
              </div>
            </div>
          </ContextWrapper>
        )}

      </GoogleReCaptchaProvider>
    </>
  );
};

export default (App); // Removed withRouter
